<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 26 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19.2492 19.4991C19.507 19.5204 19.7678 19.5312 20.0311 19.5312C21.1231 19.5312 22.1715 19.3445 23.1461 19.0013C23.1527 18.9184 23.1561 18.8346 23.1561 18.75C23.1561 17.0241 21.757 15.625 20.0311 15.625C19.3773 15.625 18.7704 15.8258 18.2687 16.169M19.2492 19.4991C19.2492 19.5098 19.2492 19.5205 19.2492 19.5312C19.2492 19.7656 19.2363 19.997 19.2112 20.2246C17.3812 21.2746 15.2604 21.875 12.9992 21.875C10.7381 21.875 8.61723 21.2746 6.78726 20.2246C6.76214 19.997 6.74924 19.7656 6.74924 19.5312C6.74924 19.5206 6.74926 19.5099 6.74932 19.4992M19.2492 19.4991C19.243 18.2735 18.8841 17.1314 18.2687 16.169M18.2687 16.169C17.1584 14.4325 15.2133 13.2812 12.9992 13.2812C10.7855 13.2812 8.84054 14.4322 7.73017 16.1683M7.73017 16.1683C7.22864 15.8255 6.62211 15.625 5.96875 15.625C4.24286 15.625 2.84375 17.0241 2.84375 18.75C2.84375 18.8346 2.84711 18.9184 2.85371 19.0013C3.82833 19.3445 4.87673 19.5312 5.96875 19.5312C6.23161 19.5312 6.49194 19.5204 6.74932 19.4992M7.73017 16.1683C7.11456 17.1309 6.75547 18.2733 6.74932 19.4992M16.1242 7.03125C16.1242 8.75714 14.7251 10.1562 12.9992 10.1562C11.2733 10.1562 9.87424 8.75714 9.87424 7.03125C9.87424 5.30536 11.2733 3.90625 12.9992 3.90625C14.7251 3.90625 16.1242 5.30536 16.1242 7.03125ZM22.3742 10.1562C22.3742 11.4507 21.3249 12.5 20.0305 12.5C18.7361 12.5 17.6867 11.4507 17.6867 10.1562C17.6867 8.86183 18.7361 7.8125 20.0305 7.8125C21.3249 7.8125 22.3742 8.86183 22.3742 10.1562ZM8.31174 10.1562C8.31174 11.4507 7.2624 12.5 5.96799 12.5C4.67357 12.5 3.62424 11.4507 3.62424 10.1562C3.62424 8.86183 4.67357 7.8125 5.96799 7.8125C7.2624 7.8125 8.31174 8.86183 8.31174 10.1562Z"
				:stroke="color"
				stroke-width="1.56"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgUsers',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
